import * as Sentry from '@sentry/react';

// Initialize Sentry only when a DSN is configured. Without a DSN, all Sentry
// API calls in the app become harmless no-ops.
export const initSentry = (): boolean => {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return false;
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '0.1'),
    release: process.env.REACT_APP_VERSION
  });
  return true;
};

export { Sentry };
